module.exports = __webpack_public_path__ + "img/addlinepoint_gray.ea72feb0.svg";